import { LoadStatus, TripStatus } from '../types/enums';
// Valid load status transitions
export const VALID_LOAD_TRANSITIONS = {
    [LoadStatus.DRAFT]: [LoadStatus.QUOTED, LoadStatus.CANCELLED],
    [LoadStatus.QUOTED]: [LoadStatus.TENDERED, LoadStatus.CANCELLED],
    [LoadStatus.TENDERED]: [LoadStatus.PENDING, LoadStatus.CANCELLED],
    [LoadStatus.PENDING]: [LoadStatus.DISPATCHED, LoadStatus.CANCELLED],
    [LoadStatus.DISPATCHED]: [LoadStatus.EN_ROUTE, LoadStatus.CANCELLED],
    [LoadStatus.EN_ROUTE]: [LoadStatus.AT_PICKUP, LoadStatus.CANCELLED],
    [LoadStatus.AT_PICKUP]: [LoadStatus.IN_TRANSIT, LoadStatus.CANCELLED],
    [LoadStatus.IN_TRANSIT]: [LoadStatus.AT_DELIVERY, LoadStatus.CANCELLED],
    [LoadStatus.AT_DELIVERY]: [LoadStatus.DELIVERED, LoadStatus.CANCELLED],
    [LoadStatus.DELIVERED]: [LoadStatus.COMPLETED, LoadStatus.INVOICED],
    [LoadStatus.COMPLETED]: [LoadStatus.INVOICED],
    [LoadStatus.INVOICED]: [LoadStatus.SETTLED],
    [LoadStatus.SETTLED]: [],
    [LoadStatus.CANCELLED]: [],
};
// Load status groups for reporting
export const LOAD_STATUS_GROUPS = {
    ACTIVE: [
        LoadStatus.PENDING,
        LoadStatus.DISPATCHED,
        LoadStatus.EN_ROUTE,
        LoadStatus.AT_PICKUP,
        LoadStatus.IN_TRANSIT,
        LoadStatus.AT_DELIVERY,
    ],
    COMPLETED: [
        LoadStatus.DELIVERED,
        LoadStatus.COMPLETED,
        LoadStatus.INVOICED,
        LoadStatus.SETTLED,
    ],
    INACTIVE: [LoadStatus.DRAFT, LoadStatus.QUOTED, LoadStatus.TENDERED, LoadStatus.CANCELLED],
};
// Load status colors for UI
export const LOAD_STATUS_COLORS = {
    [LoadStatus.DRAFT]: '#9CA3AF',
    [LoadStatus.QUOTED]: '#F59E0B',
    [LoadStatus.TENDERED]: '#8B5CF6',
    [LoadStatus.PENDING]: '#3B82F6',
    [LoadStatus.DISPATCHED]: '#06B6D4',
    [LoadStatus.EN_ROUTE]: '#EC4899',
    [LoadStatus.AT_PICKUP]: '#F97316',
    [LoadStatus.IN_TRANSIT]: '#EAB308',
    [LoadStatus.AT_DELIVERY]: '#10B981',
    [LoadStatus.DELIVERED]: '#06B6D4',
    [LoadStatus.COMPLETED]: '#059669',
    [LoadStatus.INVOICED]: '#7C3AED',
    [LoadStatus.SETTLED]: '#10B981',
    [LoadStatus.CANCELLED]: '#EF4444',
};
// Load status labels for display
export const LOAD_STATUS_LABELS = {
    [LoadStatus.DRAFT]: 'Draft',
    [LoadStatus.QUOTED]: 'Quoted',
    [LoadStatus.TENDERED]: 'Tendered',
    [LoadStatus.PENDING]: 'Pending',
    [LoadStatus.DISPATCHED]: 'Dispatched',
    [LoadStatus.EN_ROUTE]: 'En Route',
    [LoadStatus.AT_PICKUP]: 'At Pickup',
    [LoadStatus.IN_TRANSIT]: 'In Transit',
    [LoadStatus.AT_DELIVERY]: 'At Delivery',
    [LoadStatus.DELIVERED]: 'Delivered',
    [LoadStatus.COMPLETED]: 'Completed',
    [LoadStatus.INVOICED]: 'Invoiced',
    [LoadStatus.SETTLED]: 'Settled',
    [LoadStatus.CANCELLED]: 'Cancelled',
};
// Check if a status transition is valid
export function isValidLoadTransition(fromStatus, toStatus) {
    return VALID_LOAD_TRANSITIONS[fromStatus]?.includes(toStatus) ?? false;
}
// Trip status labels (WAYP-167)
export const TRIP_STATUS_LABELS = {
    [TripStatus.PLANNING]: 'Planning',
    [TripStatus.ACTIVE]: 'Active',
    [TripStatus.IN_PROGRESS]: 'In Progress',
    [TripStatus.COMPLETED]: 'Completed',
    [TripStatus.CANCELLED]: 'Cancelled',
};
export const TRIP_STATUS_COLORS = {
    [TripStatus.PLANNING]: '#9CA3AF',
    [TripStatus.ACTIVE]: '#3B82F6',
    [TripStatus.IN_PROGRESS]: '#F59E0B',
    [TripStatus.COMPLETED]: '#059669',
    [TripStatus.CANCELLED]: '#EF4444',
};
//# sourceMappingURL=status.js.map